/*
  Speed (Claude, 1 Nov 2026): Swiper now loads with `defer`, so it no longer holds up the first paint.
  layout/theme.liquid marks inline scripts that use Swiper as type="text/x-after-swiper" so they don't run
  before Swiper exists. This file is deferred straight after Swiper, so it runs them in page order once
  Swiper has loaded and before DOMContentLoaded, so their DOMContentLoaded and load listeners still fire.
*/
(function () {
  var held = document.querySelectorAll('script[type="text/x-after-swiper"]');
  for (var i = 0; i < held.length; i++) {
    var old = held[i];
    var s = document.createElement('script');
    s.text = old.text;
    old.parentNode.replaceChild(s, old);
  }
})();
